<div class="cookie-consent-sheet">
  <ng-container *ngIf="!showCustomize">
    <div class="cookie-consent-header">
      <h3 class="cookie-consent-title">{{ 'cookie-consent-title' | translate }}</h3>
      <button mat-icon-button class="close-btn" (click)="close()" [attr.aria-label]="'cookie-consent-close' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <p class="cookie-consent-message">
      {{ 'cookie-consent-message' | translate }}
    </p>
    <div class="cookie-consent-actions">
      <button mat-flat-button class="btn-accept" (click)="accept()">
        {{ 'cookie-consent-accept-all' | translate }}
      </button>
      <button mat-flat-button class="btn-reject" (click)="reject()">
        {{ 'cookie-consent-reject' | translate }}
      </button>
      <button mat-stroked-button class="btn-customize" (click)="openCustomize()">
        {{ 'cookie-consent-customize' | translate }}
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="showCustomize">
    <div class="cookie-consent-header">
      <button mat-icon-button (click)="back()" [attr.aria-label]="'cookie-consent-back' | translate">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h3 class="cookie-consent-title">{{ 'cookie-consent-customize-title' | translate }}</h3>
      <button mat-icon-button class="close-btn" (click)="close()" [attr.aria-label]="'cookie-consent-close' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="cookie-consent-toggles">
      <div class="toggle-row">
        <span class="toggle-label">
          <strong>{{ 'cookie-consent-necessary' | translate }}</strong>
          <small>{{ 'cookie-consent-necessary-desc' | translate }}</small>
        </span>
        <mat-slide-toggle [(ngModel)]="preferences.necessary" disabled></mat-slide-toggle>
      </div>
      <mat-divider></mat-divider>
      <div class="toggle-row">
        <span class="toggle-label">
          <strong>{{ 'cookie-consent-analytics' | translate }}</strong>
          <small>{{ 'cookie-consent-analytics-desc' | translate }}</small>
        </span>
        <mat-slide-toggle [(ngModel)]="preferences.analytics"></mat-slide-toggle>
      </div>
      <mat-divider></mat-divider>
      <div class="toggle-row">
        <span class="toggle-label">
          <strong>{{ 'cookie-consent-marketing' | translate }}</strong>
          <small>{{ 'cookie-consent-marketing-desc' | translate }}</small>
        </span>
        <mat-slide-toggle [(ngModel)]="preferences.marketing"></mat-slide-toggle>
      </div>
    </div>
    <div class="cookie-consent-actions">
      <button mat-flat-button class="btn-accept" (click)="saveCustomized()">
        {{ 'cookie-consent-save-preferences' | translate }}
      </button>
    </div>
  </ng-container>
</div>
